import _ from 'lodash';
import { Dropdown } from '@vibe/core';
import { dropdownValue } from '@gorilla/ui/src/components/dropdownValue';
import { useItemPicker } from '../hooks/use-item-picker';

type ItemPickerProps = {
  value?: number;
  boardId?: number;
  onChange: (itemId: number) => void;
  placeholder?: string;
};

export function ItemPicker({ value, onChange, boardId, placeholder = 'Choose an item' }: ItemPickerProps) {
  const { items, setSearchTerm, isLoading } = useItemPicker({ boardId: boardId || null, selectedItemId: value });

  const options = items.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const selectedOption = options.find((option) => option.value === value) || null;

  return (
    <Dropdown
      placeholder={placeholder}
      size="medium"
      clearable={false}
      searchable={true}
      value={dropdownValue(selectedOption)}
      options={options}
      disabled={!boardId}
      loading={isLoading}
      onInputChange={(inputValue) => {
        // v4 passes null when the input is cleared
        setSearchTerm(inputValue ?? '');
      }}
      onChange={(newSelectedOption: any) => {
        if (newSelectedOption) {
          onChange(newSelectedOption.value);
        }
      }}
      className="custom_dropdown_with_loader custom_dropdown--itempicker"
    />
  );
}
